'use strict';

/**
 * Subscribe into websocket events
 * 
 * 
 */ 

 import AuthToken from '../User/Authentication/AuthToken.js';
 import AppAuthStatus  from '../User/Authentication/AppAuthStatus.js';
 import SessionCookie  from   '../Utils/SessionCookie.js';
 import { ResourceMeta } from '../DomainResource/ResourceMeta';
 import { DomainResource } from '../DomainResource/DomainResource';
 import SubscriptionResource from '../Subscription/Subscription.js';
 import PatientDomainResource from '../Patient/Patient.js';
 import BundleParser from '../Utils/BundleParser.js';
 import UrlHelper from '../Utils/UrlHelper';
 
 import StateMachine from 'react-simple-state/dist';
 
 const appState = new StateMachine();


function WebSocketListener () {
  this.renderedTimer    = null;
  this.eventServerCommunicationInRaw = this.eventServerCommunicationInRaw.bind( this );
  //this.eventAuthenticated = this.eventAuthenticated.bind( this );
  this.eventDeAuthenticated = this.eventDeAuthenticated.bind( this );
}


/**
 * Setup event listeners
 * 
 * @param object el
 * @return void
 */
WebSocketListener.prototype.startListening = function( el ) {
  this.eventsEmitter = el;
  el.addListener( 'ServerCommunicationInRaw', this.eventServerCommunicationInRaw );
  //el.addListener( 'authenticated', this.eventAuthenticated );
  el.addListener( 'deauthenticated', this.eventDeAuthenticated );
}


/**
 * 
 * 
 * @param object eventIn
 */ 
WebSocketListener.prototype.eventServerCommunicationInRaw = function( eventIn ) {
  this.parser = new BundleParser();

  if( 
    typeof eventIn.rawJson.resourceType != 'undefined' && 
    eventIn.rawJson.resourceType == 'Bundle'
  ){
    
    // dedect logged in user after refresh
    var foundPractitionerRoleIdString = null;
    if ( !window.appLoggedInUser.isLoggedIn && eventIn.rawJson.resourceType == "Bundle") {
      for (var m in eventIn.rawJson.entry ) {
        if( 
          typeof eventIn.rawJson.entry[ m ].request != "undefined" && 
          typeof eventIn.rawJson.entry[ m ].request.method != "undefined" && 
          typeof eventIn.rawJson.entry[ m ].request.url != "undefined" && 
          eventIn.rawJson.entry[ m ].request.method == "POST" && 
          eventIn.rawJson.entry[ m ].request.url == "Person" && 
          typeof eventIn.rawJson.entry[ m ].resource != 'undefined' &&
          eventIn.rawJson.entry[ m ].resource.resourceType == "PractitionerRole"
        ){
          foundPractitionerRoleIdString = eventIn.rawJson.entry[ m ].resource.id;
          // console.log( eventIn.rawJson.entry[ m ].resource );
          window.appLoggedInUser = {
            "isLoggedIn" : true,
            "practitionerRoleId" : foundPractitionerRoleIdString
          }
          //console.log('Logged in PractitionerRole dedected: ' + foundPractitionerRoleIdString );
        }
      }
    }

    for ( var i in eventIn.rawJson.entry ){
      this.handleServerSentBundleEntry( eventIn.rawJson.entry[ i ] );
    }
    
    this.parser.handleJson(
      eventIn.rawJson, window.appEntityStore
    );
  }

  this.eventsEmitter.emit( 'ServerCommunicationHandeled', {
    'conponent' : 'WebSocketListener'
  } );
}


WebSocketListener.prototype.handleServerSentBundleEntry = function( bundleEntry ){
  let entryMeta = this.parser.extractBundleEntryMetaData( bundleEntry );
  
  if( entryMeta.resourceType == 'GuidanceResponse' ){
    if( typeof window !== "undefined" && typeof window.appLastGuidaneResesponse2 !== "undefined" ){
      window.appLastGuidaneResesponse2 = {
        "hasRecievedGR" : true,
        "isWaiting" : false,
        "guidanceResponseId" : entryMeta.resourceId
      }
    }
  }


  if( typeof bundleEntry.resource == 'undefined' || typeof bundleEntry.resource.resourceType == 'undefined' ){

    // 401 informative kind ( NEEDS_CREDENTIALS )
    // 403 Forbidden NOT_AUTHORIZED
    // 408 REQUEST_TIMEOUT 

    // de-auth check entryMeta.responseCode == 408 || 403
    // wait for token login response before acting on this message
    if( 
      entryMeta.rawResponseStatusValue.indexOf( 'NOT_AUTHORIZED' ) > -1 || 
      entryMeta.rawResponseStatusValue.indexOf( 'REQUEST_TIMEOUT' ) > -1 
    ){
      let appAuthStatus = appState.getState("app-auth-status");
      if ( appAuthStatus.isAuthenticated() ) {
        // if( this.sessionTokenResultStatus < 0 ){
          // fist time and token login results are not yet in - skip
          //console.log('Skip de-auth, waiting token login results');
          //return;
        //} else {
          console.log('De-auth command received');
          this.eventsEmitter.emit( 'deauthenticated' );
          return;
        //}
      }
    }
    
    if(  entryMeta.rawResponseStatusValue.indexOf( 'NEEDS_TOKEN' ) > -1  ){
      // 
    }
    
    if(  entryMeta.rawResponseStatusValue.indexOf( 'NEEDS_CREDENTIALS' ) > -1  ){
      // Infomative- nothing to do. Let person login via login view
      //in UK app, login anonymous #ukapp
      
      console.log('De-auth command received');
      this.eventsEmitter.emit( 'deauthenticated' );
      return;
      
      var anonymousLoginBundle = {
        "resourceType": "Bundle",
        "type": "batch",
        "entry": [{
                "resource": {
                    "resourceType": "Person",
                    "meta": {
                        "profile": ["http://documental.ee/fhir/profile/person/anonymous"]
                    },
                    "managingOrganization": {
                        "reference": "Organization/haigla"
                    }
                },
                "request": {
                    "method": "POST",
                    "url": "Person"
                }
            }
        ]
      }

      // that.connection.send(JSON.stringify( anonymousLoginBundle ));
    }

    
  }

  if( typeof bundleEntry.fullUrl !== 'undefined' && bundleEntry.fullUrl === 'Parameters/token' ){

    const parameter = bundleEntry.resource.parameter;
    const token = parameter[0].valueString;

    if (token) {
      this.eventAuthenticated( token );
    }
  }

  // Extractt app main mode runtime
  if( typeof bundleEntry.fullUrl !== 'undefined' && bundleEntry.fullUrl === 'Parameters/mode' ){
    var newMainMode = "app-main-mode-default"; // app-main-mode-default -> Estonian SR app?

    if( typeof bundleEntry.resource.parameter !== 'undefined' && typeof bundleEntry.resource.parameter[0] !== 'undefined' ){
      const parameter = bundleEntry.resource.parameter;
      const mode = parameter[0].valueCoding.code;
      
      // SELF_ASSESSMENT("self-assessment"), PRE_APPOINTMENT("pre-appointment"), DOCUMENTAL("documental"), UNKOWN("unknown");
      if( mode === "self-assessment" ){
        newMainMode = "app-main-mode-ukrainan"; // TODO: fix word typo : ukrainan -> ukrainian 
      } else if( mode === "free-assessment" ) {
        newMainMode = "app-main-mode-free-assessment";
      } else if( mode === "pre-appointment" ) {
        //newMainMode = "app-main-mode-pre-appointment";
        newMainMode = "app-main-mode-default"; // <-- check for errors before change
      } else if( mode === "repeat-visit" ){ 
        newMainMode = "app-main-mode-repeat-visit";
      } else {
        newMainMode = "app-main-mode-default";
      }
      
      // overwrite/set mode via url in debug/dev
      newMainMode = this.maybeOverrideAppMode( newMainMode );
    }

    let currentMode = appState.getState( 'app-main-mode' );
    
    // featureFlags
    let featureFlags = currentMode.featureFlags;
    if( 
      // newMainMode === 'app-main-mode-ukrainan' ||  removed from ukr mode at 2024-07-03
      newMainMode === 'app-main-mode-repeat-visit' 
    ){
      featureFlags.push({
          "featureKey" : "canChoosePractitionerFromAllServiceAtBooking",
          "enabled" : true,
          "options" : {}
      });
    }

    // only update if needed
    if( currentMode.appMainMode !== newMainMode || !currentMode.appMainModeLoaded ){
      appState.evoke( 'app-main-mode', {
        "appMainMode": newMainMode,
        "appMainModeLoaded": true,
        "featureFlags" : featureFlags
      } );
      console.log( "New mode was set to: " + newMainMode );
    }

  }  
}


/**
 * For testing other modes in localhost- add hash into url like
 * 
 * ?test-app-main-mode=app-main-mode-ukrainan
 * ?test-app-main-mode=app-main-mode-free-assessment
 * ?test-app-main-mode=app-main-mode-repeat-visit
 * 
 * @param string selectedMode 
 */
WebSocketListener.prototype.maybeOverrideAppMode = function( selectedMode ) {

  // are we on localhost or dev server?
  let runningOnLocalhost = false;
  if( typeof window.location.hostname !== "undefined" && ( window.location.hostname === "localhost" || window.location.hostname === "app.documental.ee" ) ){
    runningOnLocalhost = true;
  }
  
  if( runningOnLocalhost ){
    let urlParser = new UrlHelper();
    let testingKey = urlParser.getQueryParam( "test-app-main-mode", selectedMode );

    if( testingKey !== '' ){
      selectedMode = testingKey;
    }
  }

  return selectedMode;
}


WebSocketListener.prototype.eventAuthenticated = function( token ) {
  let authResult = new AppAuthStatus(true, new AuthToken(token));

  var sessionCookie = new SessionCookie();
  sessionCookie.createCookie(
    "app-auth-token",
    authResult.getAuthToken().getTokenAsString(),
    1
  );
  appState.evoke("app-auth-status", authResult);
  window.appEventsEmitter.emit("authenticated");

  window.appLoggedInUser = {
    "isLoggedIn" : true
  }
}


/**
 * 
 */
WebSocketListener.prototype.eventDeAuthenticated = function( eventIn ) {
  appState.evoke( 'app-auth-status', new AppAuthStatus( false, new AuthToken() ) );
  
  var sessionCookie = new SessionCookie();
  sessionCookie.eraseCookie( 'app-auth-token' );
  
  window.appLoggedInUser = {
    "isLoggedIn" : false,
    "patientId" : ""
  }

  // Should actually close, but then we need some update in login coponent to bring connection up again
  // window.apiClient.closeConnection();
  //window.apiClient.resetConnection();
  
  window.appEntityStore.clearAll();
  
  this.eventsEmitter.emit( 
    'entities-updated',  {
      'source' : 'self', 
      'entityTypes' : [],
      'allEntities' : true
    }
  );
  

  if( window.location.href.indexOf( 'localhost' ) < 0 ){
    // TODO: Should be removed and use build config instead
    //window.apiClient.resetConnection();
  }
}


export default WebSocketListener;
